<template>
  <div class="send-notice">
    <section class="form-pane">
      <div class="meta-bar">
        <div class="meta-main">
          <span class="code">{{ noticeTemplate.code || "-" }}</span>
          <span>{{ noticeSendMsg.admin ? "人工通知" : "系统通知" }}</span>
          <span v-if="noticeTemplate.flName" class="fl-name">{{ noticeTemplate.flName }}</span>
        </div>
        <el-tag size="small" :type="emergencyTag">{{ noticeTemplate.emergencyName || "普通" }}</el-tag>
      </div>

      <el-form label-width="88px" size="small" class="base-form" @submit.native.prevent>
        <el-form-item label="标题">
          <div class="plain">{{ noticeTemplate.title || "-" }}</div>
        </el-form-item>
        <el-form-item label="副标题">
          <div class="plain">{{ noticeTemplate.subTitle || "-" }}</div>
        </el-form-item>
        <el-form-item label="发送内容">
          <div class="plain content-box" v-html="noticeTemplate.content"></div>
        </el-form-item>
        <el-form-item v-for="p in contentHolders" :key="p" :label="p">
          <el-input v-model="contentParams[p]" placeholder="填充后同步到右侧预览" @input="changeContent"></el-input>
        </el-form-item>
      </el-form>

      <div v-for="field in noticeTemplate.fields" :key="field.id" class="field-block">
        <div class="field-label">{{ typeLabel(field.type) }}</div>
        <div class="field-body">
          <template v-if="field.type == 'map'">
            <div :id="field.id" class="map-box"></div>
            <div class="hint" v-if="fieldProp(field, 'value')">{{ fieldProp(field, "value") }}</div>
          </template>
          <template v-else-if="field.type == 'img' || field.type == 'vedio' || field.type == 'audio'">
            <file-upload
              multiple
              :filePath="$ossPath.kefuWecom()"
              :value="mediaUrls(field)"
              @input="setMedia(field, $event)"
            ></file-upload>
          </template>
          <template v-else-if="field.type == 'link'">
            <div class="link-line">
              <span>{{ fieldProp(field, "tip") }}</span>
              <el-link type="primary">{{ fieldProp(field, "name") || "跳转" }}</el-link>
              <el-button type="text" @click="openSetting(field)">{{
                showOrNot[field.id] ? "收起" : "调整文案"
              }}</el-button>
            </div>
            <div v-if="showOrNot[field.id]" class="tune">
              <el-input v-model="noticeSendMsg[field.id].tip" placeholder="抬头文案"></el-input>
              <el-input v-model="noticeSendMsg[field.id].name" placeholder="链接文字"></el-input>
              <el-input v-model="noticeSendMsg[field.id].value" placeholder="跳转地址"></el-input>
              <el-input v-model="noticeSendMsg[field.id].args" placeholder="链接参数"></el-input>
            </div>
          </template>
          <template v-else-if="field.type == 'input'">
            <div class="input-preview">
              <div>{{ fieldProp(field, "name") || "输入项" }}</div>
              <div class="fake-input">{{ fieldProp(field, "tip") || "请输入" }}</div>
              <div class="fake-btn">{{ fieldProp(field, "btnName") || "提交" }}</div>
            </div>
            <el-button type="text" @click="openSetting(field)">{{
              showOrNot[field.id] ? "收起" : "调整文案"
            }}</el-button>
            <div v-if="showOrNot[field.id]" class="tune">
              <el-input v-model="noticeSendMsg[field.id].name" placeholder="抬头文案"></el-input>
              <el-input v-model="noticeSendMsg[field.id].tip" placeholder="提示语"></el-input>
              <el-input v-model="noticeSendMsg[field.id].btnName" placeholder="按钮文字"></el-input>
            </div>
          </template>
        </div>
      </div>

      <div class="section-title">接收对象</div>
      <el-form label-width="88px" size="small" @submit.native.prevent>
        <el-form-item label="选择车队">
          <el-select v-model="noticeSendMsg.receiverTeam" placeholder="请选择接收车队" clearable multiple collapse-tags
            style="width: 100%">
            <el-option v-for="item in teamOpts" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="选择司机">
          <el-input v-model="noticeSendMsg.receiver" placeholder="司机编号，英文逗号分隔"></el-input>
        </el-form-item>
        <el-form-item label="延迟接收">
          <el-date-picker v-model="noticeSendMsg.postponeSendTime" type="datetime" format="yyyy-MM-dd HH:mm:ss"
            placeholder="不填则立即发送" style="width: 100%">
          </el-date-picker>
        </el-form-item>
        <el-form-item v-if="noticeTemplate.emergency != '1'" label="最迟确认">
          <el-date-picker v-model="noticeSendMsg.lastReadTime" type="datetime" format="yyyy-MM-dd HH:mm:ss"
            placeholder="最迟确认时间" style="width: 100%">
          </el-date-picker>
        </el-form-item>
      </el-form>

      <div class="footer">
        <el-button @click="closeWindow">取消</el-button>
        <el-button type="primary" @click="sendNoticeMsg">发送</el-button>
      </div>
    </section>

    <aside class="preview-pane">
      <div class="phone">
        <div class="phone-head">通知预览</div>
        <div class="phone-body">
          <div class="phone-meta">
            <span>{{ noticeTemplate.flName || "通知" }}</span>
            <span>{{ noticeTemplate.emergencyName || "普通" }}</span>
          </div>
          <div class="phone-title">{{ previewTitle || "未填写标题" }}</div>
          <div class="phone-sub" v-if="noticeTemplate.subTitle">{{ previewSubTitle }}</div>
          <div class="phone-content">{{ previewContent || "暂无内容" }}</div>

          <div v-for="field in noticeTemplate.fields" :key="'p-' + field.id" class="phone-field">
            <template v-if="field.type == 'map'">
              <img class="phone-map" src="../../../assets/image/map.png" alt="" />
              <div class="hint">{{ fieldProp(field, "value") || "地图" }}</div>
            </template>
            <template v-else-if="field.type == 'img'">
              <div v-if="mediaUrls(field).length" class="media-grid">
                <el-image
                  v-for="(url, idx) in mediaUrls(field)"
                  :key="url + idx"
                  class="phone-img"
                  :src="url"
                  :preview-src-list="mediaUrls(field)"
                  fit="cover"
                >
                  <div slot="error" class="media-empty">图片无法显示</div>
                </el-image>
              </div>
              <div v-else class="media-empty">待上传图片</div>
            </template>
            <template v-else-if="field.type == 'audio'">
              <div v-if="mediaUrls(field).length" class="media-stack">
                <audio
                  v-for="(url, idx) in mediaUrls(field)"
                  :key="url + idx"
                  class="phone-media"
                  :src="url"
                  controls
                ></audio>
              </div>
              <div v-else class="media-empty">待上传音频</div>
            </template>
            <template v-else-if="field.type == 'vedio'">
              <div v-if="mediaUrls(field).length" class="media-stack">
                <video
                  v-for="(url, idx) in mediaUrls(field)"
                  :key="url + idx"
                  class="phone-media"
                  :src="url"
                  controls
                ></video>
              </div>
              <div v-else class="media-empty">待上传视频</div>
            </template>
            <template v-else-if="field.type == 'link'">
              <div>{{ fieldProp(field, "tip") }}</div>
              <el-link type="primary">{{ fieldProp(field, "name") || "查看" }}</el-link>
            </template>
            <template v-else-if="field.type == 'input'">
              <div>{{ fieldProp(field, "name") || "输入项" }}</div>
              <div class="fake-input">{{ fieldProp(field, "tip") || "请输入" }}</div>
              <div class="fake-btn">{{ fieldProp(field, "btnName") || "提交" }}</div>
            </template>
          </div>

          <div class="phone-btns" v-if="noticeTemplate.btns && noticeTemplate.btns.length">
            <el-button v-for="btn in noticeTemplate.btns" :key="btn.id" size="mini" type="primary" plain>
              {{ btn.name }}
            </el-button>
          </div>
        </div>
      </div>
    </aside>
  </div>
</template>

<script>
const markIcon = require("@/assets/image/mark_b.png");
import { DateUtil } from "@/util/index";

export default {
  name: "NoticeForm",
  props: ["notice", "sendData"],
  data() {
    return {
      teamOpts: [],
      noticeTypeEnums: [],
      emergencyObjs: [],
      noticeTemplate: { typeObj: "", emergencyObj: "", fields: [], btns: [] },
      contentHolders: [],
      contentParams: {},
      noticeSendMsg: {
        id: null,
        receiverTeam: [],
        receiver: "",
        postponeSendTime: "",
        lastReadTime: "",
        content: ""
      },
      showOrNot: {}
    };
  },
  computed: {
    emergencyTag() {
      if (this.noticeTemplate.emergency == "3") {
        return "danger";
      }
      if (this.noticeTemplate.emergency == "2") {
        return "warning";
      }
      return "info";
    },
    previewTitle() {
      return this.fillHolders(this.noticeTemplate.title);
    },
    previewSubTitle() {
      return this.fillHolders(this.noticeTemplate.subTitle);
    },
    previewContent() {
      return this.fillHolders(this.noticeTemplate.content);
    }
  },
  mounted() {
    this.noticeTypeEnums = window.noticeTypes;
    this.emergencyObjs = window.emergencyObjs;
    this.initPage();
  },
  methods: {
    initPage() {
      this.$http.post("/admin/notice/template/" + this.notice.id, {}).then((res) => {
        let template = res.data || {};
        this.noticeTypeEnums.forEach((emu) => {
          if (emu.code == template.code) {
            template.typeObj = emu.displayName;
            return false;
          }
        });
        this.emergencyObjs.forEach((emg) => {
          if (emg.value == template.emergency) {
            template.emergencyName = emg.label;
            return false;
          }
        });
        const flOpts = window.flCodeOpts || [];
        const flHit = flOpts.find((item) => item.value == template.flCode);
        template.flName = flHit ? flHit.label : template.flCode || "";
        template.fields = template.fields || [];
        template.btns = template.btns || [];
        template.fields.forEach((field) => {
          if (field.type === "voice") {
            field.type = "audio";
          } else if (field.type === "video") {
            field.type = "vedio";
          }
        });
        this.noticeTemplate = template;
        this.initNoticeMsg();
        this.initMap();
      });
      this.$http.post("/admin/team/list", {}).then((res) => {
        let teams = res.data || [];
        let teamOpts = [];
        teams.forEach((team) => {
          teamOpts.push({ value: team.id, label: team.name });
        });
        this.teamOpts = teamOpts;
      });
    },
    initNoticeMsg() {
      this.collectHolders(this.noticeTemplate.title);
      this.collectHolders(this.noticeTemplate.subTitle);
      this.collectHolders(this.noticeTemplate.content);

      if (this.sendData.contentHolders) {
        let contentHolders = JSON.parse(this.sendData.contentHolders);
        Object.assign(this.contentParams, contentHolders);
      }
      this.noticeSendMsg.id = this.sendData.id;
      let receiverTeamIds = this.sendData.receiverTeamId || this.notice.receiverTeamId;
      if (receiverTeamIds) {
        var ids = receiverTeamIds.split(",").map((id) => parseInt(id));
        this.noticeSendMsg.receiverTeam = ids;
      }
      this.noticeSendMsg.receiver = this.sendData.receiverNo || this.notice.receiverNo;
      this.noticeSendMsg.admin = this.sendData.admin;
      this.noticeSendMsg.content = this.sendData.content || this.noticeTemplate.content || "";
      this.noticeSendMsg.postponeSendTime = this.sendData.postponeSendTime;
      this.noticeSendMsg.lastReadTime = this.sendData.lastReadTime;
      (this.noticeTemplate.fields || []).forEach((field) => {
        let valueObj = JSON.parse(JSON.stringify(field));
        if (this.sendData.fields) {
          for (var i = 0; i < this.sendData.fields.length; i++) {
            if (this.sendData.fields[i].id == field.id) {
              Object.assign(valueObj, this.sendData.fields[i]);
            }
          }
        }
        delete valueObj["id"];
        delete valueObj["type"];
        if (field.type == "img" || field.type == "audio" || field.type == "vedio") {
          valueObj.value = this.asMediaList(valueObj.value);
        }
        this.$set(this.noticeSendMsg, field.id, valueObj);
        Object.assign(field, valueObj);
        this.$set(this.showOrNot, field.id, false);
      });
      this.changeContent();
    },
    collectHolders(text) {
      const reg = /#\{\[(.+?)\]\}/g;
      const source = text || "";
      let match = reg.exec(source);
      while (match) {
        const name = match[1];
        if (name && this.contentHolders.indexOf(name) < 0) {
          this.contentHolders.push(name);
          if (this.contentParams[name] == null) {
            this.$set(this.contentParams, name, "");
          }
        }
        match = reg.exec(source);
      }
    },
    fillHolders(text) {
      let result = text || "";
      Object.keys(this.contentParams).forEach((key) => {
        const value = this.contentParams[key] == null ? "" : String(this.contentParams[key]);
        result = result.split("#{" + "[" + key + "]}").join(value);
      });
      return result;
    },
    typeLabel(type) {
      const names = {
        map: "地图",
        img: "图片",
        audio: "音频",
        vedio: "视频",
        link: "链接",
        input: "输入框"
      };
      return names[type] || "组件";
    },
    fieldProp(field, key) {
      const bag = this.noticeSendMsg[field.id];
      if (bag && bag[key]) {
        return bag[key];
      }
      return (field && field[key]) || "";
    },
    initMap() {
      let fields = this.noticeTemplate.fields || [];
      fields.forEach((field) => {
        if (field.type == "map") {
          let divId = field.id;
          this.$nextTick(() => {
            AMap.plugin(["AMap.AutoComplete", "AMap.Geocoder"], () => {
              let lngAndLat = null;
              if (field.lng && field.lat) {
                lngAndLat = [field.lng, field.lat];
              } else {
                lngAndLat = [114.254822, 30.619296];
              }
              const map = new AMap.Map(divId, {
                center: lngAndLat,
                resizeEnable: true,
                zoom: 14
              });
              map.setFitView();

              let markers = [];
              let removeMarkers = [];
              if (field.lng && field.lat) {
                let marker = new AMap.Marker({
                  icon: markIcon,
                  position: new AMap.LngLat(field.lng, field.lat),
                  draggable: true,
                  label: {
                    content: `<div class="car-info"></div>`,
                    direction: "top"
                  }
                });
                markers.push(marker);
                removeMarkers.push(marker);
                map.add(markers);
              }

              map.on("click", (e) => {
                if (removeMarkers.length) {
                  map.remove(removeMarkers);
                  removeMarkers = [];
                }
                markers = [];
                this.noticeSendMsg[field.id] = {
                  lng: e.lnglat.lng,
                  lat: e.lnglat.lat
                };
                const marker = new AMap.Marker({
                  icon: markIcon,
                  position: new AMap.LngLat(e.lnglat.lng, e.lnglat.lat),
                  draggable: true,
                  label: {
                    content: `<div class="car-info"></div>`,
                    direction: "top"
                  }
                });
                markers.push(marker);
                removeMarkers.push(marker);
                map.add(markers);
              });
            });
          });
        }
      });
    },

    changeContent() {
      this.noticeSendMsg.content = this.fillHolders(this.noticeTemplate.content);
    },

    asMediaList(value) {
      if (Array.isArray(value)) {
        return value.filter((item) => item);
      }
      if (typeof value === "string" && value) {
        return [value];
      }
      return [];
    },
    mediaUrls(field) {
      const bag = field && this.noticeSendMsg[field.id];
      const value = bag && bag.value != null && bag.value !== "" ? bag.value : field && field.value;
      return this.asMediaList(value);
    },
    setMedia(field, list) {
      if (!this.noticeSendMsg[field.id]) {
        this.$set(this.noticeSendMsg, field.id, {});
      }
      this.$set(this.noticeSendMsg[field.id], "value", this.asMediaList(list));
    },

    openSetting(field) {
      for (var p in this.showOrNot) {
        if (p != field.id) {
          this.showOrNot[p] = false;
        }
      }
      this.showOrNot[field.id] = !this.showOrNot[field.id];
    },

    sendNoticeMsg() {
      let url = "/admin/notice/sendmsg/" + this.noticeTemplate.code;
      let params = { attach: {} };
      let propNames = ["receiver", "receiverTeam", "lastReadTime", "postponeSendTime"];
      for (var p in this.noticeSendMsg) {
        if (propNames.indexOf(p) >= 0) {
          if (
            (p == "postponeSendTime" || p == "lastReadTime") &&
            this.noticeSendMsg[p] &&
            typeof this.noticeSendMsg[p] != "string"
          ) {
            params[p] = DateUtil.format(this.noticeSendMsg[p], "yyyy-MM-dd hh:mm:ss");
          } else {
            params[p] = this.noticeSendMsg[p];
          }
        } else if (Number(p) || p == "contentHolders") {
          params["attach"][p] = this.noticeSendMsg[p];
        }
      }
      params.attach.contentHolders = this.contentParams;
      params.id = this.noticeSendMsg.id;
      if (!params.receiver && (!params.receiverTeam || !params.receiverTeam.length)) {
        this.$message.error("请选择发送对象。");
        return;
      }
      this.$http.post(url, params).then((res) => {
        this.$message.success("提交成功");
        this.closeWindow(res.data);
      });
    },

    closeWindow(record) {
      this.$emit("closeWindow", record);
    }
  }
};
</script>

<style lang="less" scoped>
.send-notice {
  display: flex;
  height: calc(100vh - 180px);
  max-height: 720px;
  min-height: 480px;
  border: 1px solid #e4e7ed;
  border-radius: 4px;
  overflow: hidden;
}

.form-pane {
  flex: 1;
  min-width: 0;
  overflow: auto;
  padding: 16px 16px 8px;
}

.preview-pane {
  width: 300px;
  flex: none;
  overflow: auto;
  background: #f7f8fa;
  border-left: 1px solid #e4e7ed;
  padding: 16px;
}

.meta-bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;
}

.meta-main {
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
  color: #303133;
  font-weight: 600;
}

.code {
  font-family: Consolas, monospace;
}

.fl-name {
  color: #606266;
  font-weight: 400;
}

.plain {
  color: #303133;
  line-height: 22px;
  word-break: break-all;
}

.content-box {
  padding: 8px 10px;
  background: #f5f7fa;
  border-radius: 4px;
  white-space: pre-wrap;
}

.field-block {
  display: flex;
  margin: 0 0 12px;
}

.field-label {
  width: 88px;
  flex: none;
  padding-top: 6px;
  text-align: right;
  padding-right: 12px;
  color: #606266;
  box-sizing: border-box;
}

.field-body {
  flex: 1;
  min-width: 0;
}

.map-box {
  width: 100%;
  height: 180px;
  background: #f5f7fa;
  border-radius: 4px;
}

.hint {
  margin-top: 4px;
  color: #909399;
  font-size: 12px;
  line-height: 18px;
}

.link-line {
  display: flex;
  align-items: center;
  gap: 8px;
  min-height: 32px;
}

.tune {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-top: 8px;
}

.input-preview,
.fake-input,
.fake-btn,
.media-empty {
  color: #909399;
}

.fake-input,
.fake-btn,
.media-empty {
  margin-top: 6px;
  padding: 8px 10px;
  border: 1px dashed #dcdfe6;
  border-radius: 4px;
  background: #fafafa;
  text-align: center;
}

.fake-btn {
  margin-top: 0;
  border-top: 0;
  border-radius: 0 0 4px 4px;
  color: #606266;
}

.section-title {
  margin: 8px 0 12px;
  padding: 8px 12px;
  background: #f5f7fa;
  color: #303133;
  font-weight: 600;
}

.footer {
  position: sticky;
  bottom: 0;
  padding: 12px 0;
  text-align: right;
  background: #fff;
}

.phone {
  background: #fff;
  border: 1px solid #e4e7ed;
  border-radius: 12px;
  overflow: hidden;
}

.phone-head {
  padding: 10px 12px;
  text-align: center;
  font-weight: 600;
  background: #409eff;
  color: #fff;
}

.phone-body {
  padding: 12px;
}

.phone-meta {
  display: flex;
  justify-content: space-between;
  color: #909399;
  font-size: 12px;
}

.phone-title {
  margin-top: 8px;
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
  word-break: break-all;
}

.phone-sub {
  margin-top: 4px;
  color: #606266;
  line-height: 20px;
}

.phone-content {
  margin-top: 8px;
  color: #303133;
  line-height: 22px;
  white-space: pre-wrap;
  word-break: break-all;
}

.phone-field {
  margin-top: 10px;
}

.media-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.media-stack {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.phone-map,
.phone-img {
  width: 120px;
  height: 90px;
  border-radius: 4px;
  background: #f5f7fa;
}

.phone-media {
  width: 100%;
  max-height: 140px;
}

.phone-btns {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 12px;
}
</style>

<style lang="less">
.notice-send-dialog {
  max-width: calc(100vw - 48px);

  .el-dialog__body {
    padding: 8px 16px 16px;
  }
}
</style>
